import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import InformationTooltip from 'modules/reports/components/Editor/Field/InformationTooltip'

import styles from './index.module.css'

interface Props {
  text: string
  tooltipText?: React.ReactNode
  optional?: boolean
}

const Label = ({ text, tooltipText, optional = false }: Props) => (
  <div className={styles.outerLabel}>
    {text}&nbsp;
    {optional && (
      <span className={styles.optional}>{`(${i18n.t('custom_reports.fields.optional')})`}</span>
    )}
    {tooltipText && <InformationTooltip label={tooltipText} />}
  </div>
)

export default observer(Label)
